const PFS_LOW_RISK_DATA = [
  {
    t: 0.0,
    s: 1.0,
    lower: 1.0,
    upper: 1.0,
  },
  {
    t: 0.9,
    s: 0.9918032787,
    lower: 0.943244997,
    upper: 0.9988413014,
  },
  {
    t: 1.2,
    s: 0.9836065574,
    lower: 0.9360443376,
    upper: 0.9958746583,
  },
  {
    t: 1.4,
    s: 0.9508196721,
    lower: 0.8938095992,
    upper: 0.977600011,
  },
  {
    t: 1.5,
    s: 0.9262295082,
    lower: 0.8630298638,
    upper: 0.9609172087,
  },
  {
    t: 1.6,
    s: 0.9016393443,
    lower: 0.8332971264,
    upper: 0.9429076875,
  },
  {
    t: 1.8,
    s: 0.868852459,
    lower: 0.7948794874,
    upper: 0.9175114344,
  },
  {
    t: 1.9,
    s: 0.8524590164,
    lower: 0.7760887328,
    upper: 0.9043630023,
  },
  {
    t: 2.4,
    s: 0.8442622951,
    lower: 0.7667828934,
    upper: 0.897694426,
  },
  {
    t: 2.6,
    s: 0.8360655738,
    lower: 0.757532303,
    upper: 0.8909681264,
  },
  {
    t: 2.9,
    s: 0.8278688525,
    lower: 0.7483340741,
    upper: 0.8841874151,
  },
  {
    t: 3.0,
    s: 0.8114754098,
    lower: 0.730084602,
    upper: 0.8704741881,
  },
  {
    t: 3.1,
    s: 0.8032786885,
    lower: 0.7210289239,
    upper: 0.8635466369,
  },
  {
    t: 3.3,
    s: 0.7704918033,
    lower: 0.6852239597,
    upper: 0.835410612,
  },
  {
    t: 3.5,
    s: 0.7622069452,
    lower: 0.6762510998,
    upper: 0.8282153884,
  },
  {
    t: 3.7,
    s: 0.7538310447,
    lower: 0.6671946278,
    upper: 0.8209172444,
  },
  {
    t: 3.8,
    s: 0.7454551442,
    lower: 0.6581775196,
    upper: 0.8135815024,
  },
  {
    t: 3.9,
    s: 0.7370792437,
    lower: 0.6491984629,
    upper: 0.806209364,
  },
  {
    t: 4.0,
    s: 0.7287033432,
    lower: 0.6402562599,
    upper: 0.798801932,
  },
  {
    t: 4.1,
    s: 0.7287033432,
    lower: 0.6402562599,
    upper: 0.798801932,
  },
  {
    t: 4.2,
    s: 0.6863368698,
    lower: 0.5954457886,
    upper: 0.7608997834,
  },
  {
    t: 4.4,
    s: 0.6693902804,
    lower: 0.5777602844,
    upper: 0.7455142107,
  },
  {
    t: 4.6,
    s: 0.6609169857,
    lower: 0.5689655652,
    upper: 0.7377760193,
  },
  {
    t: 4.9,
    s: 0.652443691,
    lower: 0.560202017,
    upper: 0.730008319,
  },
  {
    t: 5.1,
    s: 0.6439703963,
    lower: 0.5514690671,
    upper: 0.7222116251,
  },
  {
    t: 5.3,
    s: 0.6267978524,
    lower: 0.5338140278,
    upper: 0.7063584893,
  },
  {
    t: 5.4,
    s: 0.6182115805,
    lower: 0.5250333662,
    upper: 0.6983884021,
  },
  {
    t: 5.6,
    s: 0.5752802207,
    lower: 0.4815808735,
    upper: 0.6581176303,
  },
  {
    t: 6.0,
    s: 0.5665638537,
    lower: 0.4728213971,
    upper: 0.6498790088,
  },
  {
    t: 6.3,
    s: 0.5491311198,
    lower: 0.4553941871,
    upper: 0.633317615,
  },
  {
    t: 6.4,
    s: 0.5311268208,
    lower: 0.4374077272,
    upper: 0.6161912192,
  },
  {
    t: 6.6,
    s: 0.5219694618,
    lower: 0.4282806185,
    upper: 0.6074599668,
  },
  {
    t: 6.7,
    s: 0.5128121028,
    lower: 0.4191904652,
    upper: 0.5986964878,
  },
  {
    t: 7.2,
    s: 0.5036547438,
    lower: 0.4101369647,
    upper: 0.5899009238,
  },
  {
    t: 7.7,
    s: 0.4476931056,
    lower: 0.3554126866,
    upper: 0.5356228605,
  },
  {
    t: 7.9,
    s: 0.4476931056,
    lower: 0.3554126866,
    upper: 0.5356228605,
  },
  {
    t: 8.3,
    s: 0.4381677204,
    lower: 0.3461972821,
    upper: 0.5262988829,
  },
  {
    t: 8.6,
    s: 0.4286423352,
    lower: 0.3370243756,
    upper: 0.5169381492,
  },
  {
    t: 8.8,
    s: 0.4191169499,
    lower: 0.3278939825,
    upper: 0.5075405124,
  },
  {
    t: 8.9,
    s: 0.4095915647,
    lower: 0.3188061799,
    upper: 0.4981057796,
  },
  {
    t: 9.0,
    s: 0.4000661795,
    lower: 0.3097611071,
    upper: 0.4886337112,
  },
  {
    t: 9.1,
    s: 0.381015409,
    lower: 0.2918000256,
    upper: 0.4695763656,
  },
  {
    t: 9.3,
    s: 0.3619646386,
    lower: 0.2740131441,
    upper: 0.4503655566,
  },
  {
    t: 9.4,
    s: 0.3524392534,
    lower: 0.2651860797,
    upper: 0.4407014524,
  },
  {
    t: 9.9,
    s: 0.3429138681,
    lower: 0.256403973,
    upper: 0.430997482,
  },
  {
    t: 10.2,
    s: 0.3429138681,
    lower: 0.256403973,
    upper: 0.430997482,
  },
  {
    t: 10.3,
    s: 0.3328281661,
    lower: 0.2470416801,
    upper: 0.4207980005,
  },
  {
    t: 10.5,
    s: 0.3328281661,
    lower: 0.2470416801,
    upper: 0.4207980005,
  },
  {
    t: 10.8,
    s: 0.3224272859,
    lower: 0.2373835887,
    upper: 0.4102967821,
  },
  {
    t: 11.2,
    s: 0.3120264057,
    lower: 0.2277939826,
    upper: 0.3997380958,
  },
  {
    t: 11.3,
    s: 0.3016255256,
    lower: 0.218273756,
    upper: 0.3891209216,
  },
  {
    t: 12.1,
    s: 0.2808237652,
    lower: 0.1994459493,
    upper: 0.3677062793,
  },
  {
    t: 12.3,
    s: 0.270422885,
    lower: 0.1901411328,
    upper: 0.35690598,
  },
  {
    t: 12.5,
    s: 0.2600220048,
    lower: 0.1809112597,
    upper: 0.3460414965,
  },
  {
    t: 12.6,
    s: 0.2496211246,
    lower: 0.1717583111,
    upper: 0.3351109156,
  },
  {
    t: 12.8,
    s: 0.2392202444,
    lower: 0.1626845559,
    upper: 0.3241120819,
  },
  {
    t: 13.4,
    s: 0.2288193642,
    lower: 0.153692586,
    upper: 0.313042567,
  },
  {
    t: 13.5,
    s: 0.2080176038,
    lower: 0.1359662563,
    upper: 0.2906801795,
  },
  {
    t: 13.8,
    s: 0.1872158434,
    lower: 0.1186084231,
    upper: 0.2679972131,
  },
  {
    t: 13.9,
    s: 0.1768149633,
    lower: 0.1100792065,
    upper: 0.2565251563,
  },
  {
    t: 14.5,
    s: 0.1657640281,
    lower: 0.1009958839,
    upper: 0.2444395548,
  },
  {
    t: 14.9,
    s: 0.1547130928,
    lower: 0.0920596725,
    upper: 0.2322290829,
  },
  {
    t: 15.4,
    s: 0.1326112224,
    lower: 0.0746692442,
    upper: 0.207397594,
  },
  {
    t: 15.9,
    s: 0.1215602872,
    lower: 0.0662407654,
    upper: 0.1947541116,
  },
  {
    t: 16.0,
    s: 0.110509352,
    lower: 0.0580121246,
    upper: 0.1819398271,
  },
  {
    t: 16.7,
    s: 0.0994584168,
    lower: 0.050004878,
    upper: 0.1689364112,
  },
  {
    t: 17.9,
    s: 0.0884074816,
    lower: 0.0422463583,
    upper: 0.1557209409,
  },
  {
    t: 18.6,
    s: 0.0884074816,
    lower: 0.0422463583,
    upper: 0.1557209409,
  },
  {
    t: 18.8,
    s: 0.0884074816,
    lower: 0.0422463583,
    upper: 0.1557209409,
  },
  {
    t: 19.5,
    s: 0.0884074816,
    lower: 0.0422463583,
    upper: 0.1557209409,
  },
  {
    t: 21.0,
    s: 0.0707259853,
    lower: 0.0285729555,
    upper: 0.1389492468,
  },
  {
    t: 21.2,
    s: 0.053044489,
    lower: 0.0169652192,
    upper: 0.1205807897,
  },
  {
    t: 25.1,
    s: 0.0353629927,
    lower: 0.007741611,
    upper: 0.1004874788,
  },
  {
    t: 25.5,
    s: 0.0353629927,
    lower: 0.007741611,
    upper: 0.1004874788,
  },
  {
    t: 29.6,
    s: 0.0,
    lower: 0.0,
    upper: 0.0,
  },
];

export default PFS_LOW_RISK_DATA;
